import React from 'react';
import { useSelector } from 'react-redux';
import Loader from 'react-loader-spinner';

import { getIsLoading } from './loadingSelectors';

export const Loading: React.FC = () => {
  const isLoading = useSelector(getIsLoading);
  const style = {
    position: 'fixed',
    top: '0',
    left: '0',
    display: 'flex',
    width: '100vw',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '99999',
  } as React.HTMLAttributes<HTMLDivElement>;

  return isLoading ? (
    <div style={style}>
      <Loader type="Grid" color="#2c84f4" height={70} width={70} />
    </div>
  ) : null;
};
